import * as React from 'react'

import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { HIDE_ERROR_POPUP } from '../../../actions/noticeActions'
import { CustomSpStore } from '../../../store'
import * as styles from './ErrorPopup.css'

interface ErrorPopupProps {
  message: string
  hideSelf: () => void
}

class ErrorPopup extends React.PureComponent<ErrorPopupProps> {
  public componentDidMount() {
    setTimeout(() => {
      this.props.hideSelf()
      // tslint:disable-next-line:align
    }, 3000)
  }

  public render() {
    return (
      <div className={styles.container}>
        <div className={styles.popup}>
          <p className={styles.popupText}>{this.props.message}</p>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state: CustomSpStore) => ({
  message: state.notice.popupErrorMessage
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  hideSelf: () => dispatch(HIDE_ERROR_POPUP())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ErrorPopup)
